import {
  menuBtn,
  navbarMenu,
  overlayMobile,
  overlayDesktop,
} from './vars';

const toggleMenu = () => {
  menuBtn.classList.toggle("open");
  navbarMenu.classList.toggle("open");
  overlayMobile.classList.toggle("open");
}

const desktopOverlay = () => {
  navbarMenu.addEventListener('mouseenter', () => {
    overlayDesktop.classList.add('open');
  })
  navbarMenu.addEventListener('mouseleave', () => {
    overlayDesktop.classList.remove('open');
  })
}

desktopOverlay();

menuBtn.addEventListener('click', () => toggleMenu());
